import script from "./StatisticsByEntity.vue?vue&type=script&setup=true&lang=js"
export * from "./StatisticsByEntity.vue?vue&type=script&setup=true&lang=js"

import "./StatisticsByEntity.vue?vue&type=style&index=0&id=178693fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-178693fb"]])

export default __exports__